const OutlineDiv = ({ children, className, ...otherProps }) => {
  return (
    <div className={`outlineDiv`} {...otherProps}>
      <div className={className}>{children}</div>
    </div>
  );
};

export default OutlineDiv;
